import React from 'react';
import { useNavigation } from 'react-router-dom';

/**
 * A thin progress bar at the top of the page that shows during route transitions.
 * Uses React Router's useNavigation to detect loading state.
 */
export const NavigationProgress: React.FC = () => {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  if (!isLoading) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-1 bg-indigo-100/50 overflow-hidden">
      <div
        className="h-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 animate-progress-bar"
        style={{
          width: '30%',
          animation: 'progress-bar 1.5s ease-in-out infinite'
        }}
      />
      <style>{`
        @keyframes progress-bar {
          0% { transform: translateX(-100%); width: 30%; }
          50% { width: 60%; }
          100% { transform: translateX(400%); width: 30%; }
        }
        .animate-progress-bar {
          animation: progress-bar 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default NavigationProgress;
